// extracted by mini-css-extract-plugin
export default {"home":"UserListPage-styles-module--home--Y0Foc","title":"UserListPage-styles-module--title--VXvdC","subtitle":"UserListPage-styles-module--subtitle--l4VAi"};